export const getSelectStyles = (error) => ({
    control: (base, state) => ({
      ...base,
      borderColor: error
        ? "#dc3545" // red if error
        : state.isFocused
        ? "#86b7fe" // bootstrap focus blue
        : "#ced4da", // normal bootstrap border

      minHeight: "38px", // match bootstrap height
    }),
  });

  export const formatSeriesLabel = (value) => {
    if (!value) return "";

    const [year, month] = value.split("-");
    const date = new Date(year, month - 1);

    return date.toLocaleString("en-US", {
      month: "long",
      year: "numeric",
    });
  };

  export const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
